import React from 'react';
import {SettingsChangePassword} from "../../../Containers";

export const MainNeedChangePasswordContainer = () => {
    return <>
        <div className="eb_content"><SettingsChangePassword/></div>
    </>;
};